(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n/kn", [], factory);
	else if(typeof exports === 'object')
		exports["i18n/kn"] = factory();
	else
		root["i18n/kn"] = factory();
})(window, function() {
return 